module.exports = __webpack_public_path__ + "media/images/category_icons/picture_dictionary-458adbe163b08a3e52f5ee5a995c24d5.svg";